import React, { useState } from 'react';
import { MessageCircle, Send, User } from 'lucide-react';
import { useTranslation } from '../../i18n/LocaleContext';

const AdminSupport = () => {
  const { t } = useTranslation();
  const [selectedChat, setSelectedChat] = useState(null);
  const [message, setMessage] = useState('');

  const chats = [
    { id: 1, user: 'Nguyễn Văn A', lastMessage: t('aSpMsgWithdraw'), time: '10:30', unread: 2, status: 'active' },
    { id: 2, user: 'Trần Thị B', lastMessage: t('aSpMsgThanks'), time: '09:15', unread: 0, status: 'resolved' },
    { id: 3, user: 'Lê Văn C', lastMessage: t('aSpMsgOrderError'), time: t('aSpYesterday'), unread: 5, status: 'active' },
    { id: 4, user: 'Phạm Thị D', lastMessage: t('aSpMsgVip'), time: t('aSpYesterday'), unread: 1, status: 'active' }
  ];

  const messages = selectedChat ? [
    { id: 1, sender: 'user', text: t('aSpChatHello'), time: '10:25' },
    { id: 2, sender: 'admin', text: t('aSpChatReply'), time: '10:26' },
    { id: 3, sender: 'user', text: t('aSpMsgWithdraw'), time: '10:30' }
  ] : [];

  const handleSend = () => {
    if (message.trim()) {
      // Handle send message
      setMessage('');
    }
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white">{t('aSpTitle')}</h1>
        <p className="text-gray-400 mt-1">{t('aSpSubtitle')}</p>
      </div>

      <div className="bg-gray-800 rounded-xl shadow-sm overflow-hidden border border-gray-700" style={{ height: 'calc(100vh - 250px)' }}>
        <div className="flex h-full">
          {/* Chat List */}
          <div className="w-1/3 border-r border-gray-700 overflow-y-auto bg-gray-900">
            <div className="p-4 border-b border-gray-700">
              <h3 className="font-semibold text-white">{t('aSpMessages', { n: chats.filter(c => c.unread > 0).length })}</h3>
            </div>
            {chats.map((chat) => (
              <div
                key={chat.id}
                onClick={() => setSelectedChat(chat)}
                className={`p-4 border-b border-gray-700 cursor-pointer hover:bg-gray-700 ${
                  selectedChat?.id === chat.id ? 'bg-gray-700' : ''
                }`}
              >
                <div className="flex items-center justify-between mb-1">
                  <p className="font-semibold text-white">{chat.user}</p>
                  <span className="text-xs text-gray-400">{chat.time}</span>
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-sm text-gray-300 truncate">{chat.lastMessage}</p>
                  {chat.unread > 0 && (
                    <span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                      {chat.unread}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Chat Window */}
          <div className="flex-1 flex flex-col">
            {selectedChat ? (
              <>
                {/* Chat Header */}
                <div className="p-4 border-b border-gray-700 flex items-center gap-3 bg-gray-900">
                  <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center">
                    <User className="w-6 h-6 text-gray-300" />
                  </div>
                  <div>
                    <p className="font-semibold text-white">{selectedChat.user}</p>
                    <p className="text-xs text-green-400">● {t('aSpOnline')}</p>
                  </div>
                </div>

                {/* Messages */}
                <div className="flex-1 overflow-y-auto p-4 space-y-4 bg-gray-800">
                  {messages.map((msg) => (
                    <div key={msg.id} className={`flex ${msg.sender === 'admin' ? 'justify-end' : 'justify-start'}`}>
                      <div className={`max-w-[70%] rounded-2xl px-4 py-2 ${
                        msg.sender === 'admin'
                          ? 'bg-brand-500 text-white'
                          : 'bg-gray-700 text-white'
                      }`}>
                        <p className="text-sm">{msg.text}</p>
                        <p className={`text-xs mt-1 ${msg.sender === 'admin' ? 'text-white/70' : 'text-gray-300'}`}>
                          {msg.time}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Input */}
                <div className="p-4 border-t border-gray-700 bg-gray-900">
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                      placeholder={t('aSpInputPlaceholder')}
                      className="flex-1 px-4 py-2 bg-gray-700 border border-gray-600 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-500"
                    />
                    <button
                      onClick={handleSend}
                      className="px-4 py-2 bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-500 transition-colors"
                    >
                      <Send className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex-1 flex items-center justify-center text-gray-500 bg-gray-800">
                <div className="text-center">
                  <MessageCircle className="w-16 h-16 mx-auto mb-4" />
                  <p>{t('aSpEmptyState')}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSupport;
